<template>
  <div class="col-md-6 col-lg-4 col-sm-12">
    <div class="row no-gutters item-card">
      <div class="col">
        <div class="card-block px-2">
          <h4 class="card-title card-small-title">{{ item.title}}</h4>
          <p class="menu-price mt-2">{{ item.price | exchange_rate_left }}</p>
        </div>
      </div>
      <img v-lazy="item.image" class="menu-image" />
      <!-- <progressive-background :src="item.image" :blur="30" no-ratio class="menu-image" /> -->
    </div>
  </div>
</template>
<script>
import store from "@/store";
export default {
  name: "itemCard",
  props: {
    item: {},
  },
  computed: {
    selected_currency() {
      return store.getters["currency/selected_currency"];
    },
  },
  methods: { 
    desc(tex) {
      if (tex) {
        return tex.substring(0, 30) + "...";
      }
    },
  },
};
</script>
<style lang="scss">
.menu-image {
  height: 120px !important; 
  border-radius: 4px !important;
}
</style>